module.exports = __webpack_public_path__ + "88e51c1c0a40666e024426a2be50c4d4.svg";